export const GetBest = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
        <path
          d='M11 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V11'
          stroke='currentcolor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M21 7.5H3' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M12 3V7.5' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M8 7.5V12' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M16 7.5V10' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M10 16.5H3' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M8 16.5V21' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M12 12H3' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <circle cx='17.5' cy='17.5' r='4.5' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M19 16.75L17.126 18.625L16 17.5' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </svg>
    </span>
  );
};
